module.exports = __webpack_public_path__ + "img/deir.1a6bb607.jpg";